import { render, staticRenderFns } from "./VipCreate.vue?vue&type=template&id=7298b5a6&scoped=true&"
import script from "./VipCreate.vue?vue&type=script&lang=js&"
export * from "./VipCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7298b5a6",
  null
  
)

export default component.exports